/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RedemptionUrlItem } from './RedemptionUrlItem';
import {
    RedemptionUrlItemFromJSON,
    RedemptionUrlItemFromJSONTyped,
    RedemptionUrlItemToJSON,
    RedemptionUrlItemToJSONTyped,
} from './RedemptionUrlItem';

/**
 * 
 * @export
 * @interface UpdateRedemptionUrlsBody
 */
export interface UpdateRedemptionUrlsBody {
    /**
     * 
     * @type {Array<RedemptionUrlItem>}
     * @memberof UpdateRedemptionUrlsBody
     */
    items: Array<RedemptionUrlItem>;
}

/**
 * Check if a given object implements the UpdateRedemptionUrlsBody interface.
 */
export function instanceOfUpdateRedemptionUrlsBody(value: object): value is UpdateRedemptionUrlsBody {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function UpdateRedemptionUrlsBodyFromJSON(json: any): UpdateRedemptionUrlsBody {
    return UpdateRedemptionUrlsBodyFromJSONTyped(json, false);
}

export function UpdateRedemptionUrlsBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRedemptionUrlsBody {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(RedemptionUrlItemFromJSON)),
    };
}

export function UpdateRedemptionUrlsBodyToJSON(json: any): UpdateRedemptionUrlsBody {
    return UpdateRedemptionUrlsBodyToJSONTyped(json, false);
}

export function UpdateRedemptionUrlsBodyToJSONTyped(value?: UpdateRedemptionUrlsBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(RedemptionUrlItemToJSON)),
    };
}

